import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const createRequest = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/request/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllRequests = async (context, scope) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/request/all`, {
    headers: setHeaders(context),
    params: { scope },
  });
  return response.data;
};

export const getAllStudentRequests = async (idStudent, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/request/getStudentRequest/${idStudent}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getRequestByID = async (idRequest, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/request/getRequestById/${idRequest}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getRequestAllInfoByID = async (idRequest, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/request/getRequestWithAllInfo/${idRequest}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllUserRequestStat = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/tache/personnelTaskStats`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllTaskStat = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/tache/getTasksWithStats`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createTaskAnswer = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/tache/createAnswerTask`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllTaskType = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/tacheType/all`, {
    headers: setHeaders(context),
  });
  return response.data;
};

export const updateTaskStatus = async (idTask, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/tache/updateTaskStatus/${idTask}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateTaskAnswer = async (idAnswer, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/tache/updateAnswerTask/${idAnswer}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteTaskAnswer = async (idAnswer, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/tache/deleteAnswerTask/${idAnswer}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateRequest = async (idRequest, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/request/update/${idRequest}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
